module.exports = __webpack_public_path__ + "static/media/free-story-subscribe-band.6dfb6cef.png";